// MyWorkspace.tsx

import React, { useState, useEffect, ReactElement } from "react";
import ReportCard from "../ReportCard/ReportCard";
import { Report } from "../../types/Report";

import { Column } from "./styles";

interface GeneralReportsProps {
    Reports: Array<Report>;
    disabled: boolean;
}

const GeneralReports = (props: GeneralReportsProps): ReactElement => {
    return (
        <>
            <div className="row">
                {props.Reports.map((item, index) => (
                    <Column key={index} className="col-md-3">
                        <ReportCard
                            Report={item}
                            disabled={props.disabled}
                        ></ReportCard>
                    </Column>
                ))}
            </div>
        </>
    );
};

export default GeneralReports;
